import { createFileRoute } from "@tanstack/react-router";
import CatalogCategoryPage from "@/site/pages/catalog-category";
import { validateCatalogSearch } from "@/site/components/catalog/catalog-search-schema";
import {
  categoryBySlugQuery,
  categoryPathFromSplat,
} from "@/site/components/catalog/category-query";
import { queryClient } from "@/lib/queryClient";

export const Route = createFileRoute("/cards/$")({
  component: CatalogCategoryPage,
  validateSearch: validateCatalogSearch,
  // Warm the header's category query on link intent (hover/focus) and on navigation.
  // Fire-and-forget: never block the transition on it — the page reserves its space.
  loader: ({ params }) => {
    const path = categoryPathFromSplat(params._splat);
    if (path) void queryClient.prefetchQuery(categoryBySlugQuery(path));
  },
});
